export default __webpack_public_path__ + "static/Photo_r-6b8ccb6ab6e9fd75382079740f8193c7.png";